import React, { Component } from 'react'
import { Col, Row, Container } from 'reactstrap';
import cubeApiClient from '../BusinessObjects/cubeApiService'
import { Redirect } from 'react-router';
import LoggedContext from '../BusinessObjects/LoggedContext'

interface ILoggedParamsProps{
    onLoggedIn?(username:string,tokenAPI:string):void;
}


export default class Login extends Component<ILoggedParamsProps,any> {
    static contextType = LoggedContext
    context!: React.ContextType<typeof LoggedContext>

    constructor(props:ILoggedParamsProps)
    {
        super(props);
        this.state ={ username:'',password:'',tokenAPI:''};
    }

    handleLogin = (event: any) => {

        var bolLogged=false;

        const service = new cubeApiClient();
        service
            .login(this.state.username,this.state.password)
            .then((data: any) => {
                this.setState({
                    loading: false,
                    tokenAPI:data.access_token,
                    username:data.userName
                });
                if(this.props.onLoggedIn !== undefined)  this.props.onLoggedIn(
                  this.state.username,
                  this.state.tokenAPI
                )
                
                this.context.setUserToken(data.userName,data.access_token);
                bolLogged = true;
                //Cerco di ottenere i dati della ditta
                
              const recsel = '?RecordSelection=' + encodeURIComponent("UserName='" + data.userName +"'");
              service
              .getItems('api/sys/UserProfile' + recsel,this.state.tokenAPI)
              .then(
                    (data: any) =>{
                                  
                                  this.context.setUserProfile(data[0]);
                                  },
                    (error:any) => {
                                  this.setState({laoding: false,error})
                    }
              );
            },
            (error: any) => {
                this.setState({
                    laoding: false,
                    error: error
                })
                alert(error);
            }); 

         
        event.preventDefault();
      }
      handleChange = (event: any) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
    
        // @ts-ignore : to avoid typescript to complain 
        this.setState({
          [name]: value
        });
      }

  render() {
    var token = this.context.tokenAPI;
    if(token > '')
    {      
     
    /*return(
      <Redirect to="/home"/>);
    }*/
    return(
      <Redirect to="/content"/>);
    }
    else
    {
    return (
        <form onSubmit={this.handleLogin}>
        <Container>

          <Row className="form-group">
            <Col className="col-3">
              <label htmlFor="username">Username</label>   
            </Col>
            <Col className="col-9">
            <input className="form-control" type="text" name="username" 
                        value={this.state.username} onChange={this.handleChange}/>
            </Col>
          </Row>
          <Row className="form-group">
            <Col className="col-3">
              <label htmlFor="password">Password</label>   
            </Col>
            <Col className="col-9">
            <input className="form-control" type="password" name="password" 
                        value={this.state.password} onChange={this.handleChange}/>
            </Col>
          </Row>
          <Row className="form-group">
              <Col className="col-6">
                <button type="submit" className="btn btn-lg btn-primary">Entra</button>
              </Col>
          </Row>
          </Container>
        </form>
    )
    }
  }
}

